<template>
  <b-modal id="add-members" centered hide-footer hide-header>
    <h3>Add Member(s)</h3>
    <b-checkbox v-model="addAdmin" class="mb-2">
      Give new members admin role
    </b-checkbox>

    <template v-if="hasPermission('user.search')">
      <b-input
        v-model="userSearch"
        debounce="500"
        placeholder="search..."
        type="search"
      />
      <b-table
        :fields="[
          { key: 'name', label: 'Name' },
          { key: 'email', label: 'Email' },
          { key: 'actions', label: '' }
        ]"
        :items="searchUsers"
        :filter="userSearch"
        :current-page="userPage"
        :per-page="10"
      >
        <template #cell(actions)="{ item }">
          <b-btn
            :disabled="item.added"
            class="p-0"
            variant="link"
            @click="addMember(item)"
          >
            <i
              :class="
                item.added
                  ? 'icon-check text-success'
                  : 'icon-plus text-primary'
              "
            />
          </b-btn>
        </template>
      </b-table>
      <b-pagination
        v-if="userTotal > 10"
        v-model="userPage"
        :total-rows="userTotal"
        :per-page="10"
        align="center"
        class="my-0"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      />
    </template>

    <template v-else>
      <b-textarea
        v-model="addEmails"
        placeholder="Enter email address(es) separated by a comma"
        type="email"
        rows="4"
      />
      <div class="mt-3 text-right">
        <b-btn class="px-4" variant="primary" @click="addMembers">
          Add {{ addAdmin ? "Admin" : "Member" }}(s)
        </b-btn>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

import API from "@/api";

export default {
  props: {
    org: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    addAdmin: false,
    addEmails: "",
    userSearch: "",
    userPage: 1,
    userTotal: 0
  }),

  computed: {
    ...mapGetters(["hasPermission"]),

    newMemberRoleIds() {
      const adminRole = this.org.roles.find(r => r.name === "Admin");
      const userRole = this.org.roles.find(r => r.name === "User");
      return [this.addAdmin ? adminRole.id : userRole.id];
    }
  },

  methods: {
    async addMember(user) {
      const { success } = await API.addOrgMember(
        this.org.id,
        user.email,
        this.newMemberRoleIds
      );
      if (!success) return;

      user.added = true;
      this.$emit("updated");
      this.$notify({
        type: "success",
        text: "Member added"
      });
    },

    async addMembers() {
      const emails = this.addEmails
        .split(",")
        .map(e => e.trim())
        .filter(v => v);

      for (const email of emails) {
        await API.addOrgMember(this.org.id, email, this.newMemberRoleIds);
      }

      this.addEmails = "";
      this.$emit("updated");
      this.$bvModal.hide("add-members");
    },

    async searchUsers(ctx) {
      const { success, results } = await API.adminUserSearch(
        this.userSearch,
        ctx.currentPage,
        ctx.perPage
      );
      if (!success) return;

      const users = results.results;
      users.forEach(user => {
        user.added = !!this.org.members.find(m => m.id === user.id);
      });

      this.userTotal = results.total;
      return users;
    }
  }
};
</script>
